var map = {
	"./davidelbar.jpeg": 506,
	"./doodle.svg": 405,
	"./evaengines.webp": 484,
	"./eveasoft.png": 281,
	"./forinov.png": 860,
	"./rap.png": 146,
	"./skate.png": 963,
	"./welease1.png": 618,
	"./welease2.png": 21
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;